// material-ui
import Box from '@mui/material/Box';
import { useColorScheme } from '@mui/material/styles';

// project imports
import { Logo, WhiteLogo } from '@/assets';
import { ThemeMode } from '@/theme/config';

// ==============================|| LOGO - ICON (BRAND OFICIAL, MENIU RESTRÂNS) ||============================== //
// Aceeași marcă oficială CityZen ca în starea extinsă, doar constrânsă la lățimea
// rail-ului: albă (SVG) pe dark, color (PNG) pe light; raport de aspect păstrat.

export default function LogoIcon() {
	const { colorScheme } = useColorScheme();
	const isDark = colorScheme === ThemeMode.DARK;
	return (
		<Box
			component="img"
			src={isDark ? WhiteLogo : Logo}
			alt="CityZen"
			sx={{ height: 34, width: 'auto', maxWidth: 44, objectFit: 'contain' }}
		/>
	);
}
